import {
  Alert,
  Button,
  Form,
  FormInstance,
  Input,
  Modal,
  Select,
  Space,
} from "antd";
import React from "react";
import {
  CreateHallFloorPayload,
  CreateHallPayload,
  CreateHallRoomPayload,
  Hall,
  HallFloor,
} from "../../interfaces";
import TextArea from "antd/lib/input/TextArea";

interface Props {
  open: boolean;
  onCancel: () => void;
  loading: boolean;
  form: FormInstance<CreateHallRoomPayload>;
  initialValues: CreateHallRoomPayload;
  onFinish: ((values: CreateHallRoomPayload) => void) | undefined;
  hall?: Hall | null;
  floor?: HallFloor | null;
}

const CreateHallFloorForm = ({
  open,
  onCancel,
  loading,
  form,
  initialValues,
  onFinish,
  hall,
  floor,
}: Props) => {
  return (
    <Modal
      title={`Add Room to ${hall?.name}, ${floor?.name}`}
      open={open}
      onCancel={onCancel}
      footer={[
        <Button type="default" key="cancel" onClick={() => onCancel()}>
          Close
        </Button>,
        <Button
          form="hallRoomForm"
          key="submit"
          htmlType="submit"
          type="primary"
          loading={loading}
        >
          {loading ? "Saving..." : "Save"}
        </Button>,
      ]}
    >
      <Form<CreateHallRoomPayload>
        form={form}
        layout="vertical"
        id="hallRoomForm"
        name="hallRoomForm"
        initialValues={initialValues}
        onFinish={onFinish}
      >
        <Form.Item hidden name="hall_id">
          <Input hidden value={hall?.id} />
        </Form.Item>
        <Form.Item hidden name="floor_id">
          <Input hidden value={floor?.id} />
        </Form.Item>
        <Alert
          message={
            <div>
              <div>
                <strong>Hall:</strong> {`${hall?.name}`}
              </div>
              <div>
                <strong>Floor:</strong> {`${floor?.name}`}
              </div>
            </div>
          }
        />
        <Form.Item
          name="name"
          label="Room Name"
          rules={[
            {
              required: true,
              message: "Please input the name of the room!",
            },
          ]}
        >
          <Input type="text" size="large" />
        </Form.Item>
        <Form.Item name="description">
          <TextArea allowClear size="large" rows={5} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateHallFloorForm;
